import Day2301 from "../images/2023/1.jpg";
import Day2302 from "../images/2023/2.jpg";
import Day2303 from "../images/2023/3.jpg";
import Day2304 from "../images/2023/4.jpg";
import Day2305 from "../images/2023/5.jpg";
import Day2306 from "../images/2023/6.jpg";
import Day2307 from "../images/2023/7.jpg";
import Day2308 from "../images/2023/8.jpg";
import Day2309 from "../images/2023/9.jpg";
import Day2310 from "../images/2023/10.jpg";
import Day2311 from "../images/2023/11.jpg";
import Day2312 from "../images/2023/12.jpg";
import Day2313 from "../images/2023/13.jpg";
import Day2314 from "../images/2023/14.jpg";
import Day2315 from "../images/2023/15.jpg";
import Day2316 from "../images/2023/16.jpg";
import Day2317 from "../images/2023/17.jpg";
import Day2318 from "../images/2023/18.jpg";
import Day2319 from "../images/2023/19.jpg";
import Day2320 from "../images/2023/20.jpg";
import Day2321 from "../images/2023/21.jpg";
import Day2322 from "../images/2023/22.jpg";
import Day2323 from "../images/2023/23.jpg";
import Day2324 from "../images/2023/24.jpg";
import Day2325 from "../images/2023/25.jpg";

import Day2401 from "../images/2024/1.jpg";
import Day2402 from "../images/2024/2.jpg";
import Day2403 from "../images/2024/3.jpg";
import Day2404 from "../images/2024/4.jpg";
import Day2405 from "../images/2024/5.jpg";
import Day2406 from "../images/2024/6.jpg";
import Day2407 from "../images/2024/7.jpg";
import Day2408 from "../images/2024/8.jpg";
import Day2409 from "../images/2024/9.jpg";
import Day2410 from "../images/2024/10.jpg";
import Day2411 from "../images/2024/11.jpg";
import Day2412 from "../images/2024/12.jpg";
import Day2413 from "../images/2024/13.jpg";
import Day2414 from "../images/2024/14.jpg";
import Day2415 from "../images/2024/15.jpg";
import Day2416 from "../images/2024/16.jpg";
import Day2417 from "../images/2024/17.jpg";
import Day2418 from "../images/2024/18.jpg";
import Day2419 from "../images/2024/19.jpg";
import Day2420 from "../images/2024/20.jpg";
import Day2421 from "../images/2024/21.jpg";
import Day2422 from "../images/2024/22.jpg";
import Day2423 from "../images/2024/23.jpg";
import Day2424 from "../images/2024/24.jpg";
import Day2425 from "../images/2024/25.jpg";

import Day2501 from "../images/2025/1.jpg";
import Day2502 from "../images/2025/2.jpg";
import Day2503 from "../images/2025/3.jpg";
import Day2504 from "../images/2025/4.jpg";
import Day2505 from "../images/2025/5.jpg";
import Day2506 from "../images/2025/6.jpg";
import Day2507 from "../images/2025/7.jpg";
import Day2508 from "../images/2025/8.jpg";
import Day2509 from "../images/2025/9.jpg";
import Day2510 from "../images/2025/10.jpg";
import Day2511 from "../images/2025/11.jpg";
import Day2512 from "../images/2025/12.jpg";
import Day2513 from "../images/2025/13.jpg";
import Day2514 from "../images/2025/14.jpg";
import Day2515 from "../images/2025/15.jpg";
import Day2516 from "../images/2025/16.jpg";
import Day2517 from "../images/2025/17.jpg";
import Day2518 from "../images/2025/18.jpg";
import Day2519 from "../images/2025/19.jpg";
import Day2520 from "../images/2025/20.jpg";
import Day2521 from "../images/2025/21.jpg";
import Day2522 from "../images/2025/22.jpg";
import Day2523 from "../images/2025/23.jpg";
import Day2524 from "../images/2025/24.jpg";
import Day2525 from "../images/2025/25.jpg";

export type Day = {
  day: number,
  text: string,
  image: string,
}

export type Year = {
  year: number,
  days: Day[],
}

export function getYear(year: number) {
  const result = Data.find(datum => datum.year === year)
  return result || { year: 1970, days: [] };
}

export function getDay(year: number, day: number) {
  const result = getYear(year).days.find(datum => datum.day === day);

  return result || { day: 0, text: "", image: "" }
}

export const Data: Year[] = [
  {
    year: 2025,
    days: [
      {
        day: 1,
        text: "Another year, another advent calendar! I love you lot sand lots and hope you enjoy it this year too ❤️😘❤️😘❤️",
        image: Day2501,
      },
      {
        day: 2,
        text: "This year has been an amazing year for you. You got your drivers licence, you published your second book, and your Twitch is absolutely taking off. I'm so proud of you!",
        image: Day2502,
      },
      {
        day: 3,
        text: "You're such a wonderful person and you genuinely have the biggest heart of anyone I know. It's one of the things I love most about you.",
        image: Day2503,
      },
      {
        day: 4,
        text: "I've been enjoying working on The Write Clean with you a lot, I'm hoping this project helps bring us even closer together and creates something cool for the world.",
        image: Day2504,
      },
      {
        day: 5,
        text: "You're such a supportive person in my life and can't thank you enough for that, especially supporting me on the parts you don't understand. I put a lot of effort into supporting you too and helping you live the life you want to.",
        image: Day2505,
      },
      {
        day: 6,
        text: "I feel so lucky everyday I wake up because I get to spend the days with you.",
        image: Day2506,
      },
      {
        day: 7,
        text: "I smile every time I remember that I married my best friend.",
        image: Day2507,
      },
      {
        day: 8,
        text: "Bunny feeding time is one of my favourite parts of the day, not just because it makes them so happy but because it makes you smile.",
        image: Day2508,
      },
      {
        day: 9,
        text: "The strange and janky games we play have changed how I view gaming for the better. I love just how much fun we have with these things and how much joy it brings you.",
        image: Day2509,
      },
      {
        day: 10,
        text: "I'm still blown away that you've got two books published, that's such an amazing feat!",
        image: Day2510,
      },
      {
        day: 11,
        text: "I know I come across as a nag sometimes but I'm always doing my best to be in your corner cheering you on, I want nothing but for you to be happy.",
        image: Day2511,
      },
      {
        day: 12,
        text: "I think starting streaming was one of your best recent ideas, it's done wonders for you. You've made amazing friends, started an excellent community, and it's helping with your writing too!",
        image: Day2512,
      },
      {
        day: 13,
        text: "I love how much we do for bunnies, not just our own but all bunnies. You've such a big heart and I'm glad you've shared your love of bunnies with me.",
        image: Day2513,
      },
      {
        day: 14,
        text: "Reading your work has felt like an honour, I don't think I could be more proud of you. Lacrimosa was especially emotional for me knowing how much of it was your lived experiences.",
        image: Day2514,
      },
      {
        day: 15,
        text: "You've grown so much in the last year and I feel special being next to you during it all. No matter what the world throws at you, I know you're tougher than it.",
        image: Day2515,
      },
      {
        day: 16,
        text: "You inspire me to be the truest me I can be because you are so you.",
        image: Day2516,
      },
      {
        day: 17,
        text: "You make a lot of people's days brighter.",
        image: Day2517,
      },
      {
        day: 18,
        text: "Your passion for what you love is so inspiring.",
        image: Day2518,
      },
      {
        day: 19,
        text: "You're a beautiful and wonderful woman, I'm incredibly lucky to be with you 🧡",
        image: Day2519,
      },
      {
        day: 20,
        text: "The fact that I get to support you doing what you love makes me incredibly happy.",
        image: Day2520,
      },
      {
        day: 21,
        text: "Our house is so full of love and life because of your big heart and keen eye for design, I appreciate that a lot.",
        image: Day2521,
      },
      {
        day: 22,
        text: "I know I say it a lot, but I truly do love you a lot 🧡",
        image: Day2522,
      },
      {
        day: 23,
        text: "The fact we own a house, have six bunnies, and have built an amazing life together blows my mind every day.",
        image: Day2523,
      },
      {
        day: 24,
        text: "Never stop being true to yourself, you've got a good heart and I think it takes your life in the right direction.",
        image: Day2524,
      },
      {
        day: 25,
        text: "I know this year has been incredibly tough, but I'm so proud of you for being tougher. I'll always be by your side through these times to support you too, you're not alone in this world 💜 I hope you have a wonderful Christmas and you've managed a solid chunk of rest.",
        image: Day2525,
      },
    ],
  },

  {
    year: 2024,
    days: [
      {
        day: 1,
        text: "I want to write you a heartfelt message for each and every day up until Christmas. I love you lots and I hope you feel that every single day we are together. I know you're burnt out at the moment and I'm doing everything in my power to lessen your load. You're an amazingly tough woman and I know you'll get through this!",
        image: Day2401,
      },
      {
        day: 2,
        text: "Everyday I wake up next to you I feel like the luckiest guy in the world. You're intelligent, beautiful, and just an all around amazing woman.",
        image: Day2402,
      },
      {
        day: 3,
        text: "I've never met anyone who is as kind as you or with nearly as big of a heart. I hope the works never crushes your desire to care for others. I know it's trying at times but I believe it's why you're able to bring joy to and lift up so many people.",
        image: Day2403,
      },
      {
        day: 4,
        text: "You published a book! That's such an amazing feat! But you haven't stopped there. You've got two more books super close and another in the pipeline. That's so amazing and I think you should step back and just appreciate how impressive that is.",
        image: Day2404,
      },
      {
        day: 5,
        text: "You brought bunnies into my life and for that I will never not be grateful. They're such wholesome and cute creatures there isn't a day that goes by I don't appreciate you introducing me to them. Even if they can be little jerks at times!",
        image: Day2405,
      },
      {
        day: 6,
        text: "I still remember our first date. It was a wonderful night. I'm sorry I didn't realise short people would struggle with those chairs! I still chuckle about the crepe place that wouldn't accept cards or that I had to go get your glasses from La Buvette on the Monday.",
        image: Day2406,
      },
      {
        day: 7,
        text: "I know we'd agreed to get married before I proposed but I still remember how nervous I was that day anyway! I'm also really glad the pizza turned out well, I remember worrying I might have messed up the dough. It's still my favourite “yes” I've gotten from you.",
        image: Day2407,
      },
      {
        day: 8,
        text: "It's the simple things sometimes that stick with me. I have such fond memories of sitting next you working on Taylor as you played through Final Fantasy Remake. How insanely excited you were to play that game. I'm honestly jealous of how excited you can get.",
        image: Day2408,
      },
      {
        day: 9,
        text: "I think often of our honeymoon in Japan. The sheer excitement you had when we got there. How well you navigated everything and how mind blowing it all was. All the crazy things we got to do. From seeing Eva’s to running Pokemon bellies for juice, it was all such a wonderful experience with you.",
        image: Day2409,
      },
      {
        day: 10,
        text: "I'm so incredibly proud of you. Ever since we first met you've been chasing dreams and crushing goals. To see how far you've come in the short time I've known you had been mind blowing. You truly are an amazing person and I'm lucky to be with you.",
        image: Day2410,
      },
      {
        day: 11,
        text: "Reading Wraiths and Wanderings for the first time was such an emotional experience for me. Not just because it was an emotional story but because I am so proud of how hard you worked to get it done. I truly appreciate being with you for that amazing journey and am excited to read even more books from you.",
        image: Day2411,
      },
      {
        day: 12,
        text: "Sometimes life gets hard, sometimes it's easy, but I'm always appreciative of your presence in my life. You lift me up and push me to be the best me I could be. I only hope I'm half as helpful to you in your life.",
        image: Day2412,
      },
      {
        day: 13,
        text: "Every day you wake up and choose to be with me and I don’t think I’ll ever appreciate anything more than that. You bring a lot of fun and love into my life.",
        image: Day2413,
      },
      {
        day: 14,
        text: "I know the Riverland isn’t your favourite place, but I do appreciate how hard you work to make it a fun trip every time we go up. I love exploring the wineries and the scenic places with you.",
        image: Day2414,
      },
      {
        day: 15,
        text: "Some of my favourite memories of us are after a long hard day of being busy we do something really calm, just the two of us. Like sitting and having a drink at 23rd Street after a long day in the Riverland. I still smile remembering you shotting my rose vodka.",
        image: Day2415,
      },
      {
        day: 16,
        text: "I can never thank you enough for introducing me to pole dancing. If I hadn’t met you, I wouldn’t have known Julia, and she would never have convinced me to start. I’m the healthiest I’ve ever been in my life and having a blast with it. Thank you.",
        image: Day2416,
      },
      {
        day: 17,
        text: "We’ve played so many fun and interesting games. I never would have experienced Phasmophobia, Plate Up, 7 Days to Die, Valheim, Overwatch, or anything like that if it weren’t for you. Also a bunch of terrible but hilarious games. My gaming repertoire has grown significantly and I think that’s helped shape my idea of what makes a game good and fun.",
        image: Day2417,
      },
      {
        day: 18,
        text: "I’m vegetarian because of you and that’s a good thing. It’s really helped further my love of cooking and take my health and diet even more seriously. This has been such a positive impact on my life and I’m thankful every day for it. ",
        image: Day2418,
      },
      {
        day: 19,
        text: "Your passion for things really does inspire me. How much you love the Titanic, Final Fantasy, and the Victorian Era is awesome. I don’t think I’ll ever tire of listening to you talk about these topics and look forward to many more years of interesting insight you have into them.",
        image: Day2419,
      },
      {
        day: 20,
        text: "Seeing you smile and giggle can light up my whole day. Nothing makes me feel better than when I’m the cause of you laughing.",
        image: Day2420,
      },
      {
        day: 21,
        text: "You’re the most kind and caring person I have ever met. You inspire me to be better just by being you and having such a big heart. I hate that the world seems to punish you for having such an amazing quality. I wish there were more I could do to help.",
        image: Day2421,
      },
      {
        day: 22,
        text: "One of my favourite things you do is when we see a bunny dreaming you almost always ask “I wonder what bunnies dream about?” and it’s just so wholesome to me. It’s such a perfect microcosm of wholesomeness. You’re cute, the bunnies cute, the idea is cute. Everything about it is cute!",
        image: Day2422,
      },
      {
        day: 23,
        text: "I know I say this a lot, but you really do have the best hugs. They truly let me know how much you love me. I hope my hugs send back a message just as strong.",
        image: Day2423,
      },
      {
        day: 24,
        text: "Thank you for always being there for me and being one of my biggest supporters. I don’t know where I’d be in life without you but I know it wouldn’t be this nice. I’m doing my best to be your biggest supporter but you have so many great friends that are competing for the title, but I won’t give up the fight!",
        image: Day2424,
      },
      {
        day: 25,
        text: "Merry Christmas! I hope this advent calendar has helped highlight just how much you mean to me and how much I love you 💝",
        image: Day2425,
      },
    ],
  },

  {
    year: 2023,
    days: [
      {
        day: 1,
        text: "Got a cute photo of all the buns lined up basking in the stream of light.",
        image: Day2301,
      },
      {
        day: 2,
        text: "Such a lovely breakfast line up.",
        image: Day2302,
      },
      {
        day: 3,
        text: "Look at those tooties.",
        image: Day2303,
      },
      {
        day: 4,
        text: "Bugs hiding in his favourite spot.",
        image: Day2304,
      },
      {
        day: 5,
        text: "Remember when there were just guinea pigs at Parabanks?",
        image: Day2305,
      },
      {
        day: 6,
        text: "Winter seems to love to hug walls while she sleeps.",
        image: Day2306,
      },
      {
        day: 7,
        text: "Latte passed out on her back is always terrifying.",
        image: Day2307,
      },
      {
        day: 8,
        text: "Bugs passed out in his favourite spot.",
        image: Day2308,
      },
      {
        day: 9,
        text: "Bugs passed out again with his little white tummy showing.",
        image: Day2309,
      },
      {
        day: 10,
        text: "Treats!",
        image: Day2310,
      },
      {
        day: 11,
        text: "Snuggle party.",
        image: Day2311,
      },
      {
        day: 12,
        text: "Winter being a guts with a whole pizza to herself.",
        image: Day2312,
      },
      {
        day: 13,
        text: "Bugs' face here says \"I was here first!\"",
        image: Day2313,
      },
      {
        day: 14,
        text: "Chilling together, but not too close!",
        image: Day2314,
      },
      {
        day: 15,
        text: "Sister's having a snooze together.",
        image: Day2315,
      },
      {
        day: 16,
        text: "I love that their ears are intertwined here.",
        image: Day2316,
      },
      {
        day: 17,
        text: "Winter just can't stay away from a snoozing Bugs.",
        image: Day2317,
      },
      {
        day: 18,
        text: "Bugs passed out in his favourite spot again.",
        image: Day2318,
      },
      {
        day: 19,
        text: "Their little tooties are touching!",
        image: Day2319,
      },
      {
        day: 20,
        text: "Winter really can't stay away from Bugs.",
        image: Day2320,
      },
      {
        day: 21,
        text: "Latte lounging in the shade of your plum tree is just too regal.",
        image: Day2321,
      },
      {
        day: 22,
        text: "Somehow this is comfy?",
        image: Day2322,
      },
      {
        day: 23,
        text: "I genuinely had to check she was alive here.",
        image: Day2323,
      },
      {
        day: 24,
        text: "Sisters stay together!",
        image: Day2324,
      },
      {
        day: 25,
        text: "A cute little family photo of our babies.",
        image: Day2325,
      },
    ],
  }
]
